export default __webpack_public_path__ + "static/media/aldemat_navicon.6e9c3887.svg";